import React from 'react';
import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {TreeItem, TreeView} from '@mui/lab';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OpenFolderIcon from 'components/icons/OpenFolderIcon';
import FolderIcon from 'components/icons/FolderIcon';
import {alpha} from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import {SingleSelectTreeViewProps} from '@mui/lab/TreeView/TreeView';

type FolderRecursiveTreeViewProps = {
   nodes: INav[];
   onNodeSelect: SingleSelectTreeViewProps['onNodeSelect'];
};

const useStyles = makeStyles((theme) => ({
   labelIcon: {
      marginRight: '5px',
   },
   group: {
      marginLeft: 7,
      paddingLeft: 17,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
   },
}));

const Node = ({node, expanded}: {node: INav; expanded: string[]}) => {
   const classes = useStyles();
   const isExpanded = expanded.some((id) => node.id === id);
   const Icon = isExpanded ? OpenFolderIcon : FolderIcon;
   return (
      <TreeItem
         classes={{group: classes.group}}
         nodeId={node.id}
         label={
            <div>
               <Icon className={classes.labelIcon} />
               {node.name}
            </div>
         }
      >
         {Array.isArray(node.child)
            ? node.child.map((childNode) => (
                 <Node key={childNode.id} node={childNode} expanded={expanded} />
              ))
            : null}
      </TreeItem>
   );
};

const FolderRecursiveTreeView = ({nodes, onNodeSelect}: FolderRecursiveTreeViewProps) => {
   const [expanded, setExpanded] = React.useState<string[]>(() => {
      return nodes.map((node) => node.id);
   });
   const handleToggle = (event: React.ChangeEvent<{}>, nodeIds: string[]) => {
      setExpanded(nodeIds);
   };

   return (
      <TreeView
         defaultCollapseIcon={<ExpandMoreIcon />}
         expanded={expanded}
         onNodeToggle={handleToggle}
         onNodeSelect={onNodeSelect}
         defaultExpandIcon={<ChevronRightIcon />}
      >
         {nodes.map((node) => (
            <Node key={node.id} node={node} expanded={expanded} />
         ))}
      </TreeView>
   );
};

export default FolderRecursiveTreeView;
